import React from "react";
import { Card, Typography } from "antd";

const PrivacyPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Privacy Policy</Typography.Title>

      <Typography.Paragraph>
        Effective Date: <strong>November 15, 2025</strong>
      </Typography.Paragraph>

      <Typography.Paragraph>
        FinKart ("App"), operated by FinKart ("Developer", "we", "our", or
        "us"), is committed to protecting your privacy and handling your
        personal information responsibly in accordance with applicable laws.
      </Typography.Paragraph>

      <Typography.Paragraph>
        <strong>Application Name:</strong> FinKart
        <br />
        <strong>Developer Name:</strong> FinKart
        <br />
        <strong>Website:</strong> https://app.finllie.com
        <br />
        <strong>Email:</strong> jpg1.jio@gmail.com
      </Typography.Paragraph>

      <Typography.Title level={4}>1. Information We Collect</Typography.Title>
      <Typography.Paragraph>
        • Name, email address, phone number, and delivery address
        <br />
        • Order details and transaction information
        <br />
        • Payment-related information processed securely through authorized
        payment providers
        <br />
        • Device information, IP address, browser details, and usage analytics
        <br />
        • Location information when required for delivery services
      </Typography.Paragraph>

      <Typography.Title level={4}>2. How We Use Your Data</Typography.Title>
      <Typography.Paragraph>
        • Processing and fulfilling orders
        <br />
        • Managing customer accounts
        <br />
        • Providing delivery updates
        <br />
        • Customer support and service improvement
        <br />
        • Fraud detection and prevention
        <br />
        • Legal and regulatory compliance
        <br />
        • Marketing communications (only with your consent where applicable)
      </Typography.Paragraph>

      <Typography.Title level={4}>3. Sharing of Data</Typography.Title>
      <Typography.Paragraph>
        We may share information with:
        <br />
        • Payment gateway providers
        <br />
        • Delivery and logistics partners
        <br />
        • Customer support providers
        <br />
        • Government authorities when required by law
        <br />
        <br />
        We do not sell personal information to third parties.
      </Typography.Paragraph>

      <Typography.Title level={4}>4. Data Security</Typography.Title>
      <Typography.Paragraph>
        We implement reasonable technical and organizational safeguards,
        including encryption, SSL-secured communications, access controls, and
        secure servers to protect personal information.
      </Typography.Paragraph>

      <Typography.Title level={4}>5. Your Rights</Typography.Title>
      <Typography.Paragraph>
        Subject to applicable laws, you may request:
        <br />
        • Access to your personal information
        <br />
        • Correction of inaccurate information
        <br />
        • Deletion of personal information
        <br />
        • Withdrawal of consent where applicable
      </Typography.Paragraph>

      <Typography.Title level={4}>
        6. Fraud Prevention & Order Validation
      </Typography.Title>

      <Typography.Paragraph>
        FinKart reserves the right to verify, cancel, hold, or reject orders in
        cases involving suspected fraud, payment manipulation, price tampering,
        unauthorized access, technical misuse, or activities that compromise
        platform integrity.
      </Typography.Paragraph>

      <Typography.Paragraph>
        If abnormal pricing, incorrect order values, or attempts to manipulate
        the platform are detected, we may cancel the order and take appropriate
        technical, legal, or administrative action.
      </Typography.Paragraph>

      <Typography.Title level={4}>7. Data Retention</Typography.Title>
      <Typography.Paragraph>
        We retain personal information only as long as necessary to provide
        services, comply with legal obligations, resolve disputes, and enforce
        agreements.
      </Typography.Paragraph>

      <Typography.Title level={4}>
        8. Changes to This Privacy Policy
      </Typography.Title>
      <Typography.Paragraph>
        We may update this Privacy Policy from time to time. Updated versions
        will be published within the application and on our website.
      </Typography.Paragraph>

      <Typography.Title level={4}>9. Contact Us</Typography.Title>
      <Typography.Paragraph>
        Developer: FinKart
        <br />
        Website: https://app.finllie.com
        <br />
        Email: jpg1.jio@gmail.com
        <br />
        Phone: +91 9945089397
      </Typography.Paragraph>
    </Card>
  </div>
);

export default PrivacyPage;